import { forwardRef } from "react";

import { Core } from "..";
import * as S from "./styles";

// eslint-disable-next-line react/display-name
export const Date = forwardRef(({ gridArea, margin, ...props }, ref) => {
  return (
    <S.DateInputWrapper gridArea={gridArea} margin={margin}>
      <Core ref={ref} {...props} />
    </S.DateInputWrapper>
  );
});
